import { render, staticRenderFns } from "./Priority.vue?vue&type=template&id=3b468cfb&scoped=true"
import script from "./Priority.vue?vue&type=script&lang=js"
export * from "./Priority.vue?vue&type=script&lang=js"
import style0 from "./Priority.vue?vue&type=style&index=0&id=3b468cfb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b468cfb",
  null
  
)

export default component.exports